import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { AgentGetAsCollection, AgentGetAsCollectionResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<AgentGetAsCollectionResponse, AgentGetAsCollectionResponse>) => {
    return response?.data?.agents
}
const getError = (response?: SWRResponse<AgentGetAsCollectionResponse, AgentGetAsCollectionResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<ContractGetCollectionByLotIdResponse, ContractGetCollectionByLotIdResponse>) => ({});

const useAgents = (configuration?: SWRConfiguration<AgentGetAsCollectionResponse, AgentGetAsCollectionResponse>) => {
    
    const request = useMemo(() => {
        return () => {
            return new AgentGetAsCollection();
        };
    }, [])

    return useGet(request, { getData, getError }, configuration);
}

export default useAgents;